<template>
<svg viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-JiaDian`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.2557 0.275391H6.88172C5.96404 0.275391 5.21753 1.02188 5.21753 1.93959V15.9909C5.21753 16.9086 5.96402 17.6551 6.88172 17.6551H12.2557C13.1734 17.6551 13.9199 16.9086 13.9199 15.9909V1.93959C13.9199 1.0219 13.1734 0.275391 12.2557 0.275391ZM6.88172 1.38486H12.2557C12.5615 1.38486 12.8104 1.63379 12.8104 1.93959V8.47907H6.327V1.93959C6.327 1.63378 6.57591 1.38486 6.88172 1.38486ZM12.2557 16.5457H6.88172C6.57591 16.5457 6.327 16.2967 6.327 15.991V9.58852H12.8104V15.9909C12.8104 16.2967 12.5615 16.5457 12.2557 16.5457Z" :fill="useCurrentColor ? 'currentColor' : '#000'"/><path d="M7.27836 7.92297C7.58471 7.92297 7.83308 7.67459 7.83308 7.36824V6.81352C7.83308 6.50716 7.58471 6.25879 7.27836 6.25879 6.97201 6.25879 6.72363 6.50716 6.72363 6.81352V7.36824C6.72361 7.67457 6.97201 7.92297 7.27836 7.92297zM7.27836 10.1436C6.97201 10.1436 6.72363 10.3919 6.72363 10.6983V11.253C6.72363 11.5594 6.97201 11.8077 7.27836 11.8077 7.58471 11.8077 7.83308 11.5594 7.83308 11.253V10.6983C7.83308 10.3919 7.58469 10.1436 7.27836 10.1436z" :fill="useCurrentColor ? 'currentColor' : '#000'"/></svg>
</template>
<script>

export default {
  name: 'IconJiaDian',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
